export const STORAGE_KEY = 'responsecx_chat_history';
export const THREAD_ID_STORAGE_KEY = 'responsecx_thread_id';
export const SESSIONS_METADATA_KEY = 'responsecx_sessions_metadata';
export const CURRENT_SESSION_KEY = 'responsecx_current_session';
export const SESSION_DATA_PREFIX = 'responsecx_session_';
